import { useState } from 'react';
import styled from '@emotion/styled';

import { generateClockInnerTickAngles } from './clockUtils';
import { Tick } from './Tick';

const Container = styled.div`
  position: absolute;
  inset: 0;
`;

export const ClockInnerRing = () => {
  const [tickAngles] = useState(() => generateClockInnerTickAngles());

  return (
    <Container>
      {tickAngles.map((angle, i) => (
        <Tick index={i} angle={angle} key={angle} />
      ))}
    </Container>
  );
};
